module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/ms-icon-144x144-9ec09036c8632f9cdcfaacaf4e77bafb.png";